export default __webpack_public_path__ + "static/media/mso_icon3.9de6e3ce.svg";